import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { createSelector } from 'reselect';
import { getSelectedModuleSchema } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getIsUngatedForModuleVersioning } from 'ContentEditorUI/redux/selectors/authSelectors';
export const getModuleVersions = basicSelector(state => state.moduleVersions);
export const getModuleHasUpgradeAvailable = createSelector(getSelectedModuleSchema, getModuleVersions, getIsUngatedForModuleVersioning, (moduleSchema, moduleVersions, isUngatedForModuleVersioning) => {
  const modulesWithVersionUpgrades = moduleVersions && moduleVersions.upgradableAssets;
  const moduleSchemaPath = moduleSchema && moduleSchema.path;
  return moduleSchemaPath && isUngatedForModuleVersioning && modulesWithVersionUpgrades && modulesWithVersionUpgrades[moduleSchemaPath];
});